import React from 'react';
import PropTypes from 'prop-types';

import { STATUS_LABELS } from './moment_stream_helpers';

import './StatusChip.scss';

// Lifecycle chip for a moment. `runStatus === 'running'` overrides the stored
// status label — a rebuild on an already-reviewed moment still reads "Building…".
const StatusChip = ({ status, runStatus }) => (
  <span className={`msa-status-chip is-${status}`}>
    {runStatus === 'running' ? 'Building…' : STATUS_LABELS[status] || status}
  </span>
);

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  runStatus: PropTypes.string
};

export default StatusChip;
